import { postRequest } from '@/core';
import { tripTemplates } from '@/requests';

export default async function getGeneratedTripsRequest(tripIds) {
	let url = tripTemplates.getGeneratedTripsPath();
	let generatedTrips = await postRequest(url, {}, tripIds);
	return generatedTrips;
}